import {
  Box,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from '@mui/material'
import { ResponseNumberSubTypeEnum } from '@ulysses-inc/harami_api_client'
import type { FormikProps } from 'formik'
import type { FC } from 'react'
import { SubTypeText } from 'src/constants/responseNumber'
import type { NumberRuleProps } from './EditResponseNumberRuleEnableProductMasterDrawer'

export const FixedRuleSelector: FC<{
  formikProps: FormikProps<NumberRuleProps>
}> = ({
  formikProps: {
    values: { subType, minimum, maximum, scale },
    handleChange,
    setFieldValue,
  },
}) => {
  const update = (key: keyof NumberRuleProps) => (value: unknown) =>
    setFieldValue(key, value)

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <Stack direction="row" spacing={0.5} alignItems="center">
        {subType !== ResponseNumberSubTypeEnum.LESS_THAN && (
          <TextField
            type="number"
            size="small"
            name="minimum"
            placeholder="0"
            value={minimum ?? ''}
            onChange={e =>
              update('minimum')(
                e.target.value === '' ? undefined : Number(e.target.value),
              )
            }
            slotProps={{ htmlInput: { 'aria-label': '正常値の下限値' } }}
            sx={{ width: 90 }}
          />
        )}
        {(!subType || subType === ResponseNumberSubTypeEnum.BETWEEN) && (
          <Typography>ー</Typography>
        )}
        {subType !== ResponseNumberSubTypeEnum.GREATER_THAN && (
          <TextField
            type="number"
            size="small"
            name="maximum"
            placeholder="100"
            value={maximum ?? ''}
            onChange={e =>
              update('maximum')(
                e.target.value === '' ? undefined : Number(e.target.value),
              )
            }
            slotProps={{ htmlInput: { 'aria-label': '正常値の上限値' } }}
            sx={{ width: 90 }}
          />
        )}
      </Stack>
      <Stack direction="row" spacing={0.5} alignItems="center">
        <TextField
          size="small"
          name="scale"
          placeholder="℃"
          value={scale ?? ''}
          onChange={handleChange}
          slotProps={{ htmlInput: { 'aria-label': '正常値の単位' } }}
          sx={{ width: 80 }}
        />
        <Select<ResponseNumberSubTypeEnum | ''>
          displayEmpty
          size="small"
          value={subType ?? ''}
          onChange={e => update('subType')(e.target.value || undefined)}
          inputProps={{ 'aria-label': '正常値の範囲指定' }}
          renderValue={value =>
            value === '' ? (
              <Box component="span" sx={{ color: 'text.disabled' }}>
                の間
              </Box>
            ) : (
              SubTypeText[value]
            )
          }
          sx={{ width: 80 }}
        >
          <MenuItem
            value={ResponseNumberSubTypeEnum.BETWEEN}
            data-testid="select-number-subtype-item"
          >
            {SubTypeText[ResponseNumberSubTypeEnum.BETWEEN]}
          </MenuItem>
          <MenuItem
            value={ResponseNumberSubTypeEnum.GREATER_THAN}
            data-testid="select-number-subtype-item"
          >
            {SubTypeText[ResponseNumberSubTypeEnum.GREATER_THAN]}
          </MenuItem>
          <MenuItem
            value={ResponseNumberSubTypeEnum.LESS_THAN}
            data-testid="select-number-subtype-item"
          >
            {SubTypeText[ResponseNumberSubTypeEnum.LESS_THAN]}
          </MenuItem>
        </Select>
      </Stack>
    </Stack>
  )
}
